module.exports={
  "modules": {
    "dateFunctions": {
      "require": "./lib/date-functions",
      "type": "value"
    },
    "endOfGrain": {
      "require": "./lib/end-of-grain",
      "type": "value"
    },
    "endsWithId": {
      "require": "./lib/ends-with-id",
      "type": "value"
    },
    "moment": "moment",
    "omitMeta": {
      "require": "./lib/omit-meta",
      "type": "value"
    },
    "stringToMomentThatMayNeverBeMutated": {
      "require": "./lib/string-to-moment-that-may-never-be-mutated",
      "type": "value"
    },
    "timestampString": {
      "require": "./lib/timestamp-string",
      "type": "value"
    },
    "u": {
      "require": "./import",
      "type": "value"
    }
  }
}
